import Vue from 'vue';
import { getApiHostWithoutEnv } from '@fund/api-host';
import axios from 'axios';

export default {
  state: {
    fund: {},
  },
  mutations: {
    updateBasicInformation(state, { id, data }) {
      // 变更状态
      const fundData = data.Datas;
      // fundData.ISSEDATE = '2020-07-01 15:00:00';
      if (data.Expansion) {
        fundData.Expansion = data.Expansion;
      }
      // const startTime = state.fund[`startTime${id}`];
      // if (startTime && startTime.length > 0) {
      //   if (startTime !== '') {
      //     fundData.ISSBDATE = startTime;
      //   }
      // }
      // fundData.ISSBDATE = '2020-11-24 16:37:00';
      // fundData.ISSEDATE = '2020-11-25 18:24:00';
      // fundData.BUY = false;
      Vue.set(state.fund, id, fundData);
    },
    updateBasicInformationJH(state, { id, data }) {
      // 存储数据
      Vue.set(state.fund, `newdate${id}`, data);
    },
    // 容灾
    updateBasicInformationJH2(state, { id, data }) {
      // 存储数据
      Vue.set(state.fund, `newdate${id}`, data);
    },
    updatefetchFundDynamicInfo(state, { id, data }) {
      // 变更状态
      let startTime = '';
      if (data) {
        if (data.succeed) {
          if (data.result) {
            if (data.result.futureMarket) {
              if (data.result.futureMarket.length > 0) {
                const item = data.result.futureMarket[0];
                console.log(item);
                if (item.beginTime && item.beginTime.length > 0) {
                  const temps = item.beginTime.split('.');
                  const name = temps[0];
                  const temps2 = name.split('T');
                  if (temps2.length >= 2) {
                    startTime = `${temps2[0]} ${temps2[1]}`;
                  }
                }
              }
            }
          }
        }
      }
      Vue.set(state.fund, `startTime${id}`, startTime);
    },
  },
  actions: {
    updateBasicInformation({ commit, rootState }) {
      const baseURL = getApiHostWithoutEnv('fundmobapi');
      const mainurl = `${baseURL}/FundMNewApi/FundMNNBasicInformation`;
      const curTime = new Date().getTime();
      return new Promise((resolve, reject) => {
        axios.get(mainurl, {
          params: {
            FCODE: rootState.native.fund.fundCode,
            deviceid: '1234567.py.service',
            version: '6.5.5',
            product: 'EFund',
            plat: 'web',
            rand: curTime,
          },
        })
          .then((json) => {
            commit('updateBasicInformation', {
              id: rootState.native.fund.fundCode,
              data: json.data,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
    updateBasicInformationJH({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('FundApi.getFundMainInfo', rootState.native.fund.fundCode)
          .then((json) => {
            console.log(json);
            commit('updateBasicInformationJH', {
              id: rootState.native.fund.fundCode,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
    // 容灾数据
    updateBasicInformationJH2({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('FundApi.getFundMainInfo2', rootState.native.fund.fundCode)
          .then((json) => {
            console.log(json);
            commit('updateBasicInformationJH2', {
              id: rootState.native.fund.fundCode,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
    updatefetchFundDynamicInfo({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('FundApi.getNewFundStartTimeList', id)
          .then((json) => {
            commit('updatefetchFundDynamicInfo', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
  },
  getters: {
    currentBaseInfo(state, getters, rootState) {
      return state.fund[rootState.native.fund.fundCode];
    },
  },
};
